/**
 * Detect when Nova (ASSISTANT / "student") text has drifted into coach-style speech.
 * Used to trigger an immediate role reminder and to keep drifted turns out of
 * session-rotation history rehydration.
 */

const COACH_TELL_PATTERNS = [
  /\bwe can figure this out\b/i,
  /\bwhat (?:do you think )?would help\b/i,
  /\bwhat would help most\b/i,
  /\bi(?:'m| am) (?:here|open) to listen/i,
  /\bi(?:'m| am) here for you\b/i,
  /\bhow can i help\b/i,
  /\bhow can i support\b/i,
  /\bhow can i assist\b/i,
  /\blet'?s (?:work|figure|talk) (?:this|that|it) through\b/i,
  /\bit sounds like you(?:'re| are)\b/i,
  /\bi hear (?:that )?you(?:'re| are)\b/i,
  /\bwhat i(?:'m| am) hearing\b/i,
  /\bas your coach\b/i,
  /\bhow does that make you feel\b/i,
  /\bwould you like to talk about\b/i,
  /\bi(?:'m| am) (?:happy|here) to (?:help|support|listen)\b/i,
  /\btogether we can\b/i,
  /\bi want to (?:help|support) you\b/i,
];

/**
 * @param {string} text
 * @returns {boolean}
 */
export function looksLikeCoachSpeech(text) {
  if (!text || typeof text !== 'string') return false;
  const trimmed = text.trim();
  if (trimmed.length < 12) return false;
  return COACH_TELL_PATTERNS.some((re) => re.test(trimmed));
}
